/* eslint-disable import/prefer-default-export */

import { DateTime } from 'luxon';

export function cleanMenuItem({
  url, type, object, title: text,
}) {
  let to;

  switch (type) {
    case 'post_type_archive':
      to = {
        story: { name: 'stories' },
        product: { name: 'programs' },
      }[object];

      break;
    case 'post_type': {
      const segments = url.split('/').filter(Boolean);

      to = {
        name: 'page',
        params: {
          page: segments[segments.length - 1],
        },
      };

      break;
    }
    default:
  }

  return { text, to };
}

export function cleanMember({ title: { rendered: name }, slug, acf }) {
  return {
    name,
    slug,
    ...acf,
  };
}

export function cleanAdvisor({ title: { rendered: name }, acf }) {
  return {
    name,
    ...acf,
  };
}

export function cleanPartner({ title: { rendered: name }, acf }) {
  return {
    name,
    ...acf,
  };
}

function cleanDate(date) {
  return DateTime.fromISO(date).toFormat('LLL d');
}

function cleanSession({
  start_date: startDate,
  end_date: endDate,
}) {
  return [startDate, endDate].map(cleanDate).join(' – ');
}

function makeMonths(sessions) {
  const months = [];

  sessions.forEach((session) => {
    const sessionMonthName = DateTime.fromISO(session.start_date).monthShort;

    let month = months.find(({ name: monthName }) => monthName === sessionMonthName);

    if (!month) {
      month = {
        name: sessionMonthName,
        sessions: [],
      };

      months.push(month);
    }

    month.sessions.push(cleanSession(session));
  });

  return months;
}

function cleanTime(time) {
  if (!time) {
    return null;
  }

  return DateTime.fromISO(time).toLocaleString(DateTime.TIME_SIMPLE);
}

function cleanSeason({
  name,
  days,
  display,
  options,
  pricing,
  columns,
  sessions,
  description,
  end_time: endTime,
  start_time: startTime,
  'days_&_times': daysTimes,
}) {
  const season = {};

  switch (display) {
    case 'options':
      season.columns = columns;
      season.options = options;
      season.description = description;

      break;
    case 'description_only':
      season.description = description;

      break;
    case 'sessions_only':
      season.sessions = sessions.map(cleanSession);

      break;
    case 'sessions_within_months':
      season.months = makeMonths(sessions);

      break;
    default:
  }

  return {
    display,
    name,
    days,
    time: startTime && endTime ? [startTime, endTime].map(cleanTime).join(' - ') : null,
    pricing,
    daysTimes,
    ...season,
  };
}

function cleanElement({ ID: id }) {
  return id;
}

export function cleanProgram({
  acf: {
    ages,
    hero,
    badge,
    levels,
    seasons,
    overview,
    description,
    images: elements,
    custom_sign_up_link: signUpUrl,
  },
  title: { rendered: name },
}) {
  return {
    name,
    hero,
    experience: {
      description,
      elements: elements ? elements.map(cleanElement) : [],
    },
    details: {
      badge,
      attributes: [
        { name: 'Ages', value: ages },
        { name: 'Levels', value: levels },
      ],
      overview,
      seasons: seasons.map(cleanSeason),
    },
    signUpUrl,
  };
}
